import { render, staticRenderFns } from "./TeamMemberList.vue?vue&type=template&id=59f80d52&scoped=true&"
import script from "./TeamMemberList.vue?vue&type=script&lang=js&"
export * from "./TeamMemberList.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberList.vue?vue&type=style&index=0&id=59f80d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f80d52",
  null
  
)

export default component.exports